import { IBrandLead } from "@faire/web-api--source/indigofair/data/IBrandLead";
export var SOURCE_OPTIONS = function(strictLocalize) {
    return [
        {
            label: strictLocalize({
                id: "5bGX59",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Social Media"
                    }
                ]
            }),
            value: IBrandLead.Source.SOCIAL_MEDIA
        },
        {
            label: strictLocalize({
                id: "RePkaA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Another Brand"
                    }
                ]
            }),
            value: IBrandLead.Source.BRAND_REFERRAL
        },
        {
            label: strictLocalize({
                id: "1RLlJw",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A Retailer"
                    }
                ]
            }),
            value: IBrandLead.Source.RETAILER_REFERRAL
        },
        {
            label: strictLocalize({
                id: "topGp+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "A Faire employee"
                    }
                ]
            }),
            value: IBrandLead.Source.FAIRE_EMPLOYEE
        },
        {
            label: strictLocalize({
                id: "/VnDMl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Other"
                    }
                ]
            }),
            value: IBrandLead.Source.ORGANIC
        }
    ];
};
